import { Outlet, Link, Route } from "react-router-dom";
import styles from "./Layout.module.css";
//import Azure from "../../assets/Azure.svg";
import Logo from "../../../assets/genie-logo.svg";
import { CopyRegular, ShareRegular } from "@fluentui/react-icons";
import { useLocation } from "react-router-dom";

import sepdot from "../../../assets/sep-dot.svg";
import jarvis from "../../../assets/jarvis-icon.png";

import {
  CommandBarButton,
  Dialog,
  Stack,
  TextField,
  ICommandBarStyles,
  IButtonStyles,
  DefaultButton,
} from "@fluentui/react";
import {
  useContext,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import {
  AppDropDown,
  ModelDropdown,
  SunDropdownAi,
} from "../../../components/common/Dropdown";
import { AppStateContext } from "../../../state/AppProvider";

import { useNavigate } from "react-router-dom";

import { Tooltip as ReactTooltip } from "react-tooltip";

// interface LayoutProps {
//   onNewChat: () => void;
//   simpleHeader?: boolean;  // optional prop
// }

interface LayoutProps {
  onNewChat: () => void;
  simpleHeader?: boolean; // optional prop
  isToggled: boolean;
  setIsToggled: Dispatch<SetStateAction<boolean>>;
}

const shareButtonStyles: ICommandBarStyles & IButtonStyles = {
  root: {
    width: 86,
    height: 32,
    borderRadius: 4,
    background:
      "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)",
    //   position: 'absolute',
    //   right: 20,
    padding: "5px 12px",
    marginRight: "20px",
  },
  icon: {
    color: "#FFFFFF",
  },
  rootHovered: {
    background:
      "linear-gradient(135deg, #0F6CBD 0%, #2D87C3 51.04%, #8DDDD8 100%)",
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#FFFFFF",
  },
};

// const Layout = ({ onNewChat }: { onNewChat: () => void; simpleHeader?: boolean  }) => {

const Layout = ({
  onNewChat,
  simpleHeader,
  isToggled,
  setIsToggled,
}: LayoutProps) => {
  const [isSharePanelOpen, setIsSharePanelOpen] = useState<boolean>(false);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [copyClicked, setCopyClicked] = useState<boolean>(false);
  const [copyText, setCopyText] = useState<string>("Copy URL");
  const [useAvatar, setUseAvatar] = useState(false);
  const appStateContext = useContext(AppStateContext);
  const navigate = useNavigate();
  const [Opentoggle, setonpentoggle] = useState(false);
  const [selectedModel, setSelectedModel] = useState<string>("");
  const isPrysmView = localStorage.getItem("PrysmView") === "1";

  //const [isToggled, setIsToggled] = useState(false);

  //  const [isToggled, setIsToggled] = useState(() => {
  //   const saved = localStorage.getItem("dark-theme-enabled");ust
  //   return saved === "true" ? true : false;
  // });

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
  };

  const handleShareClick = () => {
    setIsSharePanelOpen(true);
  };
  //   const handleLogout = async () => {
  //   localStorage.removeItem("AccessToken");
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("profileImage");
  //   localStorage.removeItem("name");
  //   localStorage.removeItem("jobTitle");
  //   localStorage.removeItem("Expertise");
  //   localStorage.removeItem("Entraid");
  //   localStorage.removeItem("Email");

  //   await fetch(`${BackendURL}/api/logout`, {
  //     method: "POST",
  //     credentials: "include",
  //   });

  //   navigate("/signin");
  // };

  const handleSharePanelDismiss = () => {
    setIsSharePanelOpen(false);
    setCopyClicked(false);
    setCopyText("Copy URL");
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopyClicked(true);
  };

  const handleClearHistory = () => {
    setIsPopupOpen(true);
    //const clearChatHistory = 'clear';
    //appStateContext?.dispatch({ type: 'CLEAR_CHAT_HISTORY', payload: clearChatHistory });
  };
  const handleYesPopup = () => {
    const clearChatHistory = "clear";
    appStateContext?.dispatch({
      type: "CLEAR_CHAT_HISTORY",
      payload: clearChatHistory,
    });
    setIsPopupOpen(false);
  };
  const handleClearPopupDismiss = () => {
    setIsPopupOpen(false);
  };

  const handleHistoryClick = () => {
    appStateContext?.dispatch({ type: "TOGGLE_CHAT_HISTORY" });
    setonpentoggle((prevState) => !prevState);
  };

  const handleQuestionClick = () => {
    appStateContext?.dispatch({ type: "TOGGLE_PROMT_PANEL" });
  };

  const handelClick = () => {
    window.location.reload();
  };

  //   useEffect(() => {
  //   if (isToggled) {
  //     document.body.classList.add("dark-theme");
  //     localStorage.setItem("dark-theme-enabled", "true");
  //     console.log("dark theme")
  //   } else {
  //     document.body.classList.remove("dark-theme");
  //     localStorage.setItem("dark-theme-enabled", "false");
  //     console.log("light theme")
  //   }
  // }, [isToggled]);

  useEffect(() => {
    if (copyClicked) {
      setCopyText("Copied URL");
    }
  }, [copyClicked]);

  useEffect(() => { }, [appStateContext?.state.isCosmosDBAvailable.status]);

  function handleExportClick(): void { }

  //   const handleToggle = () => {
  //     setUseAvatar(!useAvatar);
  //   };

  const Userguide: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    // <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M13 10.8571V1.71429C13 0.76928 12.2045 0 11.2273 0H2.95455C1.32585 0 0 1.28214 0 2.85714V13.7143C0 14.9743 1.05995 16 2.36364 16H12.4091C12.7356 16 13 15.7443 13 15.4286C13 15.1129 12.7356 14.8571 12.4091 14.8571H11.2273V12.5714C12.2045 12.5714 13 11.8021 13 10.8571ZM10.0455 14.8571H2.36364C1.71216 14.8571 1.18182 14.3443 1.18182 13.7143C1.18182 13.0843 1.71216 12.5714 2.36364 12.5714H10.0455V14.8571ZM2.36364 11.4286C1.93376 11.4286 1.52971 11.54 1.18182 11.735V2.85711C1.18182 1.9121 1.97732 1.14282 2.95455 1.14282H11.2273C11.553 1.14282 11.8182 1.39924 11.8182 1.71425V10.8571C11.8182 11.1721 11.553 11.4285 11.2273 11.4285L2.36364 11.4286ZM7.68182 9.14286C7.68182 9.45858 7.41739 9.71429 7.09091 9.71429H3.54545C3.21897 9.71429 2.95455 9.45858 2.95455 9.14286C2.95455 8.82714 3.21897 8.57143 3.54545 8.57143H7.09091C7.41739 8.57143 7.68182 8.82714 7.68182 9.14286ZM10.0455 3.42857C10.0455 3.74429 9.78103 4 9.45455 4H3.54545C3.21897 4 2.95455 3.74429 2.95455 3.42857C2.95455 3.11285 3.21897 2.85714 3.54545 2.85714H9.45455C9.78103 2.85714 10.0455 3.11285 10.0455 3.42857ZM10.0455 6.28571C10.0455 6.60144 9.78103 6.85714 9.45455 6.85714H3.54545C3.21897 6.85714 2.95455 6.60144 2.95455 6.28571C2.95455 5.96999 3.21897 5.71429 3.54545 5.71429H9.45455C9.78103 5.71429 10.0455 5.96999 10.0455 6.28571Z" fill="currentColor"/>
    // </svg>
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.96207 9.84252C5.96207 10.3066 6.33909 10.6829 6.80418 10.6829C7.26926 10.6829 7.64629 10.3066 7.64629 9.84252V5.80884C7.64629 5.34473 7.26926 4.96851 6.80418 4.96851C6.33909 4.96851 5.96207 5.34473 5.96207 5.80884V9.84252Z"
        fill="currentColor"
      />
      <path
        d="M6.05453 3.76366C6.05453 4.22777 6.43156 4.604 6.89665 4.604C7.36173 4.604 7.73876 4.22777 7.73876 3.76366V3.57278C7.73876 3.10868 7.36173 2.73245 6.89665 2.73245C6.43156 2.73245 6.05453 3.10868 6.05453 3.57278V3.76366Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 2.77895C0 1.24418 1.24158 0 2.77314 0H10.8404C12.372 0 13.6135 1.24418 13.6135 2.77895V11.7895H13.6168V13.3052C13.4698 13.3052 13.3922 13.356 13.3371 13.4232C13.2695 13.5056 13.2021 13.6616 13.2021 13.8947C13.2021 14.2203 13.4655 14.4841 13.7903 14.4841V16H2.10086C0.940598 16 2.50732e-05 15.0574 0 13.8948V2.77895ZM12.101 2.77895V11.7895H2.10086C1.89667 11.7895 1.69928 11.8187 1.51262 11.8731V2.77895C1.51262 2.08133 2.07697 1.51579 2.77314 1.51579H10.8404C11.5366 1.51579 12.101 2.08133 12.101 2.77895ZM1.51262 13.8947C1.51262 13.5692 1.77599 13.3052 2.10086 13.3052H11.7576C11.7115 13.4981 11.6894 13.6969 11.6894 13.8947C11.6894 14.0993 11.7186 14.2972 11.7729 14.4841H2.10086C1.776 14.4841 1.51264 14.2203 1.51262 13.8947Z"
        fill="currentColor"
      />
    </svg>
  );

  const location = useLocation();

  const isAdminPage = location.pathname.startsWith("/admin");
  const headerLabel = isPrysmView ? "Jarvis" : "Lipi";

  //     useEffect(() => {
  //   if (isAdminPage) {
  //     document.body.classList.remove("dark-theme");
  //     return;
  //   }
  //   localStorage.setItem("dark-theme-enabled", isToggled.toString());

  //   if (isToggled) {
  //     document.body.classList.add("dark-theme");

  //   } else {
  //     document.body.classList.remove("dark-theme");

  //   }
  // }, [isToggled, isAdminPage]);

  const NewChatSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.264 0.812573C12.3473 -0.270858 14.104 -0.270858 15.1874 0.812573C16.2709 1.896 16.2709 3.65259 15.1874 4.73602L9.91028 10.0132C9.23033 10.6931 8.34826 11.1341 7.39633 11.2701L5.45863 11.5469C5.18168 11.5865 4.90226 11.4934 4.70444 11.2956C4.50662 11.0977 4.41348 10.8183 4.45304 10.5414L4.72986 8.60366C4.86585 7.65173 5.30691 6.76958 5.98684 6.08968L11.264 0.812573ZM13.9304 2.06955C13.5412 1.68034 12.9101 1.68034 12.5209 2.06955L7.24381 7.34669C6.83584 7.75466 6.57124 8.28386 6.48965 8.85502L6.38041 9.61959L7.14489 9.51035C7.71604 9.42876 8.24534 9.16415 8.65331 8.75618L13.9304 3.47904C14.3196 3.08982 14.3196 2.45878 13.9304 2.06955ZM7.11058 0.889385C7.11093 1.38026 6.71336 1.77851 6.22247 1.7789C5.33495 1.77959 4.70871 1.78619 4.2188 1.83274C3.73914 1.87831 3.45297 1.95764 3.23356 2.06944C2.73183 2.32508 2.32392 2.733 2.06827 3.23472C1.949 3.4688 1.86708 3.77784 1.82313 4.31572C1.77834 4.86399 1.77764 5.56821 1.77764 6.57848V9.42271C1.77764 10.4329 1.77834 11.1372 1.82313 11.6854C1.86708 12.2233 1.949 12.5323 2.06827 12.7664C2.32392 13.2681 2.73183 13.6761 3.23356 13.9317C3.46763 14.051 3.77667 14.1328 4.31456 14.1768C4.86282 14.2216 5.56704 14.2224 6.57729 14.2224H9.42152C10.4318 14.2224 11.136 14.2216 11.6843 14.1768C12.2221 14.1328 12.5311 14.051 12.7653 13.9317C13.267 13.6761 13.6749 13.2681 13.9305 12.7664C14.0423 12.547 14.1217 12.2608 14.1672 11.7812C14.2138 11.2913 14.2204 10.665 14.2211 9.77753C14.2214 9.28663 14.6197 8.88897 15.1106 8.88942C15.6015 8.88977 15.9991 9.28806 15.9987 9.77886C15.998 10.6483 15.9928 11.3611 15.9369 11.9493C15.8801 12.5478 15.7664 13.079 15.5144 13.5734C15.0884 14.4096 14.4085 15.0895 13.5723 15.5156C13.0459 15.7838 12.4768 15.8957 11.829 15.9485C11.1999 16 10.4229 16 9.45956 16H6.53924C5.57593 16 4.79897 16 4.1698 15.9485C3.52199 15.8957 2.95297 15.7838 2.42653 15.5156C1.59032 15.0895 0.910448 14.4096 0.484382 13.5734C0.216144 13.047 0.104321 12.478 0.051392 11.8302C-1.74679e-05 11.201 -8.65454e-06 10.4241 2.33681e-07 9.46075V6.54044C-8.65454e-06 5.57711 -1.74679e-05 4.80014 0.051392 4.17096C0.104321 3.52314 0.216144 2.95413 0.484382 2.42769C0.910448 1.59147 1.59032 0.911614 2.42653 0.485539C2.92096 0.233612 3.45218 0.119922 4.05067 0.0630644C4.63893 0.00717521 5.35163 0.00193114 6.22106 0.00125563C6.71194 0.000873437 7.11022 0.398497 7.11058 0.889385Z"
        fill="currentColor"
      />
    </svg>
  );

  const handleButtonClick = () => {
    window.open(
      "https://genieprodexternalstorage.blob.core.windows.net/genieusermanual/LipiUserManual.pdf",
      "_blank",
    );
  };

  return (
    <div className={styles.layout}>
      <header className={styles.header} role={"banner"}>
        <Stack
          horizontal
          verticalAlign="center"
          horizontalAlign="space-between"

          // className={styles.headerContainer}
        >
          <Stack
            horizontal
            tokens={{ childrenGap: 8 }}
            className={`${styles.NewChatWrapper} ${styles.action_btn_gap}`}
          >
            <div id="newChat" className={styles.NewChatWrapper}>
              {isPrysmView ? (
                <div className={styles.sidebarHeaderLogo}>
                  <div className={styles.JarvisHeaderWrapper}>
                    <img
                      src={jarvis}
                      alt="Jarvis"
                      className={styles.jarvislogo}
                    />
                    <div className={styles.jarvisDesc}>
                      <div className={styles.jarvisDescRow1}>
                        <span className={styles.jarvistext}>{headerLabel}</span>
                        <Stack
                          className="SelectModal"
                          data-tooltip-id="lipiApps"
                        >
                          <ModelDropdown />
                        </Stack>
                      </div>
                      <div className={styles.jarvisDescRow2}>
                        <span className={styles.assestOpen}>1 asset open </span>
                        <span className={styles.sepdot}>
                          <img src={sepdot} alt="sep" width="4" height="4" />
                        </span>
                        <div className={styles.watchingWorkText}>
                          Watching your workspace
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`${styles.sidebarHeaderLogo} ${sideBarEnable || isAdminPage
                      ? styles.sidebarHLogo_active
                      : styles.sidebarHLogo_inactive
                    } `}
                >
                  <div className={styles.JarvisHeaderWrapper}>
                    <img
                      src={appLogo || Logo}
                      alt={headerLabel}
                      className={styles.jarvislogo}
                    />
                    <div className={styles.jarvisDesc}>
                      <div className={styles.jarvisDescRow1}>
                        <span className={styles.jarvistext}>{headerLabel}</span>
                        <div>

                          <Stack
                            className="SelectModal"
                            data-tooltip-id="lipiApps"
                          >
                            <ModelDropdown />
                          </Stack>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Stack>
        </Stack>
      </header>
      <Outlet />
      <Dialog
        onDismiss={handleClearPopupDismiss}
        hidden={!isPopupOpen}
        styles={{
          main: [
            {
              selectors: {
                ["@media (min-width: 480px)"]: {
                  maxWidth: "600px",
                  background: "#FFFFFF",
                  boxShadow:
                    "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  maxHeight: "270px",
                  minHeight: "100px",
                },
              },
            },
          ],
        }}
        dialogContentProps={{
          //title: "Share the web app",
          showCloseButton: false,
        }}
      >
        <Stack horizontal verticalAlign="center" style={{ gap: "8px" }}>
          <div className={styles.popupWrp}>
            <div className={styles.popupIco}>
              <svg
                _ngcontent-pbk-c15=""
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g _ngcontent-pbk-c15="" clip-path="url(#clip0_134_8)">
                  <path
                    _ngcontent-pbk-c15=""
                    d="M18.0003 8.5H17.9997C17.6455 8.5002 17.2953 8.5746 16.9715 8.71839C16.6478 8.86219 16.3578 9.0722 16.1202 9.33489C15.8826 9.59759 15.7026 9.90714 15.5919 10.2436C15.4812 10.5801 15.4423 10.936 15.4775 11.2885L16.2646 19.1759C16.3026 19.6092 16.5013 20.0127 16.8218 20.307C17.1432 20.6021 17.5636 20.7659 18 20.7659C18.4364 20.7659 18.8568 20.6021 19.1782 20.307C19.4987 20.0127 19.6974 19.6092 19.7354 19.1759L20.5225 11.2885C20.5225 11.2884 20.5225 11.2884 20.5225 11.2884C20.5577 10.936 20.5187 10.5801 20.4081 10.2436C20.2974 9.90714 20.1174 9.59759 19.8798 9.33489C19.6422 9.0722 19.3522 8.86219 19.0285 8.71839C18.7047 8.57459 18.3545 8.5002 18.0003 8.5ZM35.5 18C35.5 22.6413 33.6563 27.0925 30.3744 30.3744C27.0925 33.6563 22.6413 35.5 18 35.5C13.3587 35.5 8.90752 33.6563 5.62563 30.3744C2.34374 27.0925 0.5 22.6413 0.5 18C0.5 13.3587 2.34374 8.90752 5.62563 5.62563C8.90752 2.34374 13.3587 0.5 18 0.5C22.6413 0.5 27.0925 2.34374 30.3744 5.62563C33.6563 8.90752 35.5 13.3587 35.5 18ZM18.0045 22C17.2752 22 16.5757 22.2897 16.06 22.8055C15.5442 23.3212 15.2545 24.0207 15.2545 24.75C15.2545 25.4793 15.5442 26.1788 16.06 26.6945C16.5757 27.2103 17.2752 27.5 18.0045 27.5C18.7338 27.5 19.4333 27.2103 19.949 26.6945C20.4648 26.1788 20.7545 25.4793 20.7545 24.75C20.7545 24.0207 20.4648 23.3212 19.949 22.8055C19.4333 22.2897 18.7338 22 18.0045 22Z"
                    stroke="black"
                  ></path>
                </g>
                <defs _ngcontent-pbk-c15="">
                  <clipPath _ngcontent-pbk-c15="" id="clip0_134_8">
                    <rect
                      _ngcontent-pbk-c15=""
                      width="36"
                      height="36"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span className={styles.popupText}>
              Are you sure you want to clear the <br />
              conversation?
            </span>
            <button
              className={styles.yesBtn}
              onClick={handleYesPopup}
              type="button"
            >
              Yes
            </button>
            <button
              className={styles.noBtn}
              onClick={handleClearPopupDismiss}
              type="button"
            >
              No
            </button>
          </div>
        </Stack>
      </Dialog>
      <Dialog
        onDismiss={handleSharePanelDismiss}
        hidden={!isSharePanelOpen}
        styles={{
          main: [
            {
              selectors: {
                ["@media (min-width: 480px)"]: {
                  maxWidth: "600px",
                  background: "#FFFFFF",
                  boxShadow:
                    "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  maxHeight: "200px",
                  minHeight: "100px",
                },
              },
            },
          ],
        }}
        dialogContentProps={{
          title: "Share the web app",
          showCloseButton: true,
        }}
      >
        <Stack horizontal verticalAlign="center" style={{ gap: "8px" }}>
          <TextField
            className={styles.urlTextBox}
            defaultValue={window.location.href}
            readOnly
          />
          <div
            className={styles.copyButtonContainer}
            role="button"
            tabIndex={0}
            aria-label="Copy"
            onClick={handleCopyClick}
            onKeyDown={(e) =>
              e.key === "Enter" || e.key === " " ? handleCopyClick() : null
            }
          >
            <CopyRegular className={styles.copyButton} />
            <span className={styles.copyButtonText}>{copyText}</span>
          </div>
        </Stack>
      </Dialog>
    </div>
  );
};

export default Layout;
